import React from "react";

const GeneralSettingsTab = ({
  group,
  groupName,
  setGroupName,
  handleCopyCode,
  handleSave,
  isSaving,
  handleDeleteGroup,
}) => {
  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <div className="settings-card-icon">⚙️</div>
        <h2 className="settings-card-title">General Settings</h2>
      </div>

      <div className="settings-form-group">
        <label className="settings-label">Group Title / Name</label>
        <input
          type="text"
          className="settings-input-text"
          value={groupName}
          onChange={(e) => setGroupName(e.target.value)}
          placeholder="Enter Group Name"
        />
      </div>

      <div className="settings-form-group">
        <label className="settings-label">Group Access Code (PIN)</label>
        <div className="settings-pin-box">
          <span className="settings-pin-code">{group?.code || "N/A"}</span>
          <button
            type="button"
            className="settings-copy-btn"
            onClick={handleCopyCode}
          >
            📋 Copy Code
          </button>
        </div>
      </div>

      <div className="settings-form-group" style={{ marginTop: "24px" }}>
        <label className="settings-label">Group Metadata</label>
        <div
          style={{
            background: "#f8fafc",
            borderRadius: "14px",
            padding: "16px",
            border: "1px solid #e2e8f0",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            fontSize: "13px",
            color: "#64748b",
          }}
        >
          <div>
            <strong>Folder Name:</strong> {group?.folderName || "N/A"}
          </div>
          <div>
            <strong>Total Photos:</strong> {group?.media?.length || 0} Photos
          </div>
          <div>
            <strong>Created On:</strong>{" "}
            {group?.createdAt
              ? new Date(group.createdAt).toLocaleDateString()
              : "N/A"}
          </div>
        </div>
      </div>

      <div className="settings-actions-footer" style={{ marginTop: "24px", paddingBottom: "24px", borderBottom: "1px solid #e2e8f0" }}>
        <button
          type="button"
          className="settings-save-btn"
          onClick={handleSave}
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : "Save General Settings"}
        </button>
      </div>

      <div className="settings-danger-zone" style={{ marginTop: "24px" }}>
        <h3 style={{ color: "#ef4444", fontSize: "16px", marginBottom: "8px" }}>🚨 Danger Zone</h3>
        <p style={{ color: "#64748b", fontSize: "13px", marginBottom: "16px" }}>
          Once you delete a group, there is no going back. Please be certain. All photos and data will be permanently removed.
        </p>
        <button
          type="button"
          onClick={handleDeleteGroup}
          disabled={isSaving}
          style={{
            background: "#fee2e2",
            color: "#ef4444",
            border: "1px solid #f87171",
            padding: "10px 16px",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "500",
            cursor: "pointer",
            width: "100%",
            textAlign: "center"
          }}
        >
          Delete This Group
        </button>
      </div>
    </div>
  );
};

export default GeneralSettingsTab;
